export const LIST_ACCESS = 'list/access'
